import React from 'react'
import LocationReportView from './LocationReportView'
import { useLocationReport } from './useLocationReport'
const LocationReport = (): JSX.Element => {
  const state = useLocationReport()
  return <LocationReportView {...state} />
}

export default LocationReport
